import { PaymentInfoType } from '@kinderlabs-pos/shared-data-type';

const getTotalPayments = (payments: PaymentInfoType[]) => {
	return payments.filter((p) => !p.refunded).reduce((arr, pay, idx) => arr + pay.amount, 0);
};

export const PaymentUtil = {
	getTotal: getTotalPayments,
};
